import { render, staticRenderFns } from "./donor-team-info-page.vue?vue&type=template&id=26adf878&scoped=true&"
import script from "./donor-team-info-page.vue?vue&type=script&lang=js&"
export * from "./donor-team-info-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26adf878",
  null
  
)

export default component.exports